import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../../constants/styles';
let { ICON_DEFAULT_SIZE, ICON_DEFAULT_COLOR } = constants;

let styles = {
  base: {
    fontSize: ICON_DEFAULT_SIZE,
    color: ICON_DEFAULT_COLOR
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/common/icon/Icon.styles.js